import { type AppInfo } from 'api/types/AppInfo';

export const filteredRegions = ['us'];

// TODO: Standardize this function's implementation across all specific app-views, even when directly accessed via URL. (e.g.: /info/:id, /training/:id, /retain/:id, /training/:id/:chapter/:page etc.). Should probably all cause a redirect, rather than an error or accessible depending on which view.
export const approveAppByCountry = ({ regionHidden }: AppInfo, country: string) => {
  return regionHidden === false || (!!country && filteredRegions.includes(country?.toLowerCase()) === false);
};
